export default __webpack_public_path__ + "static/media/CU42x0.d0fcc1e8.jpg";